const updateObjectByPath = (object, path, newValue) => {
  const pathLength = path.length;
  let output = { ...object };
  let currentNode = output;

  path.forEach((value, index) => {
    if (typeof currentNode[value] === undefined) {
      currentNode[value] = {};
    }

    if (index === pathLength - 1) {
      currentNode[value] = newValue;
      return;
    }

    if (typeof currentNode[value] === 'object') {
      if (Array.isArray(currentNode[value])) {
        currentNode[value] = [...currentNode[value]];
      } else {
        currentNode[value] = { ...currentNode[value] };
      }
    }

    currentNode = currentNode[value];
  });
  return output;
};

export default updateObjectByPath;
